
// возвращает случайное время от текущего + случайный период из диапазона 5-6 минут
const getRandomExpired = () => (Date.now() + (Math.floor(Math.random() * (360000 - 300000)) + 300000));

export default getRandomExpired;
